<div class="age-gate" role="dialog" aria-modal="true" aria-labelledby="ageTitle" aria-describedby="ageDesc">
 <div class="overlay" aria-hidden="true"></div>
 <div class="age-modal" tabindex="-1">
  <h1 id="ageTitle" class="sr-only">Age Verification</h1>

  <img src="assets/images/age-logo.png" alt="Highlife Health logo" class="age-illustration" />

  <p id="ageDesc">
   {{ ageVerification?.text ? ageVerification?.text:'You must be at least 21 years old to make purchases' }}?
  </p>

  <div class="actions">
   <button class="btn primary" (click)="confirmAge()" [attr.aria-label]="'Yes, I am at least ' + (ageVerification?.age || 21) + ' years old'">I am {{ ageVerification?.age || 21 }}+</button>

   <button class="btn secondary" (click)="denyAge()" aria-label="Exit the website">Exit</button>
  </div>
 </div> 
</div>
